import {useCallback} from 'react';
import useUpdatePayinSessionMutation from 'src/api/graphql/useUpdatePayinSessionMutation';
import {getStore} from 'src/v2/state/store';
import type {OpenapiCryptocurrencyPayinsResourceSupportedCurrencyCurrencyNetworkEnum} from '@stripe-internal/data-v1/schema/types';

type UpdateRefundAddressParams = {
  refundAddress: string | null;
  destinationNetwork: OpenapiCryptocurrencyPayinsResourceSupportedCurrencyCurrencyNetworkEnum;
};

export const useUpdateRefundAddress = (): [
  (params: UpdateRefundAddressParams) => Promise<void>,
  {loading: boolean},
] => {
  const store = getStore();
  const [updatePayinSessionMutation, {loading}] =
    useUpdatePayinSessionMutation();
  const sessionId = store.useSelector((state) => state.id);
  const clientSecret = store.useSelector((state) => state.clientSecret);

  const updateRefundAddress = useCallback(
    async ({refundAddress, destinationNetwork}: UpdateRefundAddressParams) => {
      // When clearing (refundAddress is null), send empty string to clear on backend
      // When setting, send the actual address
      const refundParams = {
        refund_data: {
          refund_address: refundAddress ?? '',
          destination_network: destinationNetwork,
        },
      };

      console.log('[useUpdateRefundAddress] Calling mutation with:', {
        sessionId,
        clientSecret: clientSecret ? '***' : null,
        refundAddress,
        destinationNetwork,
        refundParams,
      });

      const result = await updatePayinSessionMutation({
        variables: {
          input: {
            client_secret: clientSecret,
            crypto_payin_session: sessionId,
            refund_params: refundParams,
          },
        },
      });

      console.log('[useUpdateRefundAddress] Mutation result:', result);
    },
    [sessionId, clientSecret, updatePayinSessionMutation],
  );

  return [updateRefundAddress, {loading}];
};
